<template>
  <div class="workbenches">
    <div class="workbenches-head">
      <span class="f-blue">欢迎您</span>

      <el-link
        class="fr"
        icon="iconfont icon-tuichudenglu"
        :underline="false"
        @click="logout"
        >退出登录</el-link
      >
      <!-- <el-link class="fr" icon="el-icon-set-up" :underline="false" @click="openCompanyDialog" style="margin-right:10px">切换组织</el-link> -->
      <span class="fr">您好，{{ userInfo.nickName }}</span>
    </div>
    <div class="workbenches-box">
      <el-row>
        <el-col :span="16">
          <div class="w-box" style="margin-right: 16px">
            <div class="w-b-head">
              <div class="tit fl">
                <b>应用场景</b>
              </div>
              <!-- <div class="fr">
                <el-link icon="iconfont icon-shuaxin" :underline="false">刷新</el-link>
                <el-link :underline="false">查看更多 +</el-link>
              </div> -->
            </div>

            <div class="use-cases">
              <template v-for="workbenchMenu in workbenchMenus">
                <div class="item" :key="workbenchMenu.id">
                  <div class="t">
                    <span>{{ workbenchMenu.menuName }}</span>
                  </div>
                  <div class="c">
                    <div
                      class="i-block"
                      v-for="(router2, index1) in workbenchMenu.children"
                      :key="index1"
                      @click="openRoutePath(router2)"
                    >
                      <i
                        class="icon iconfont"
                        :class="router2.menuImg || 'icon-charge-fill'"
                        :style="
                          'background-color: ' +
                          (router2.menuImgColor || '#3B82F6') +
                          ';'
                        "
                      ></i>
                      <span>{{ router2.menuName }}</span>
                      <span class="tips" v-if="!!router2.note">{{
                        router2.note
                      }}</span>
                    </div>
                    <!-- <div class="i-block">
                        <i class="icon iconfont icon-charge-fill" style="background-color:#3B82F6"></i>

                        <span>研发费用付款</span>
                        <span class="tips">(技术转让费、设计开发费、检测费、试验费、信息费、标准化费用)</span>
                      </div> -->
                  </div>
                </div>
              </template>
            </div>

            <!-- <template v-for="menuModule in $baseEventBus.menuModules">
            <div class="use-cases" style="height: calc(100vh - 193px);" :key="menuModule.id" v-show="menuModule.id === $baseEventBus.currentMenuId">

                  <div class="item" v-for="router1 in menuModule.children" :key="router1.id">
                    <div class="t"><span>{{router1.menuName}}</span></div>
                    <div class="c">
                      <div class="i-block" v-for="(router2, index1) in router1.children"
                  :key="index1" @click="rourteTo(router2)"><i class="icon" style="background-color: #3B82F6;">{{router2.menuName.substring(0,1)}}</i><span>{{router2.menuName}}</span></div>
                    </div>
                  </div>
            </div>
            </template> -->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="w-box" style="height: 60%">
            <div class="w-b-head">
              <div class="tit fl">
                <b>待办事项</b>
                <i class="nums">{{ unDoWfRows.length }}</i>
              </div>
              <div class="fr">
                <el-link :underline="false" @click="toWfManageList"
                  >查看更多 +</el-link
                >
              </div>
            </div>
            <div class="agenda-box">
              <div
                class="item"
                v-for="item in unDoWfRows"
                :key="item.id"
                @click="openWfDialog(item)"
              >
                <p class="name">{{ item.name }}</p>
                <p class="info">
                  <span>单据类型：{{ item.objTypeName }}</span>
                  <span>启动人：{{ item.starterName }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="w-box" style="margin-top: 16px; height: calc(40% - 16px)">
            <div class="w-b-head">
              <div class="tit fl">
                <b>通知公告</b>
                <i class="nums">{{ systemNotices.length }}</i>
              </div>
              <div class="fr">
                <el-link :underline="false" @click="openSystemNoticeDialog()"
                  >查看更多 +</el-link
                >
              </div>
            </div>
            <div class="wnotice-box">
              <!-- <div class="item">
                <i class="no-read">未读</i>
                <span class="name">紧急通知</span>
                <span class="date">2025-10-12</span>
              </div> -->
              <div
                class="item"
                v-for="systemNotice in systemNotices"
                :key="systemNotice.id"
                @click="openSystemNoticeDialog(systemNotice)"
              >
                <span class="name">{{ systemNotice.title }}</span>
                <span class="date">{{
                  systemNotice.modifyDate.substring(0, 10)
                }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="workbenches-info">
      <div class="w-left">
        <span>角色申请：李鹏00575023 （“项目预算与费用管理”模块：郑潇涵19010359）</span>
        <span>运维人员：林上家A1010633 | 王瑾瑾01499274<i style="padding-left:24px"></i>©2023 海尔新能源 版权所有</span>
      </div>
    </div>
    -->
    <systemNoticeInfoDialog
      v-if="showSystemNoticeInfoDialog"
      :visiable.sync="showSystemNoticeInfoDialog"
      :param="csnRow"
      :appendToTop="true"
    ></systemNoticeInfoDialog>
    <wfContentDialog
      v-if="showWfDialog"
      :visible.sync="showWfDialog"
      @close="wfClose"
      :option.sync="wfContentOption"
    ></wfContentDialog>
    <el-dialog
      title="切换组织"
      width="355px"
      custom-class="dialog-style list-dialog"
      v-if="showCompanyDialog"
      :visible.sync="showCompanyDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      v-el-drag-dialog
      v-el-dialog-center
      @close="changeCompanyClose"
    >
      <div class="cont">
        <el-input
          placeholder="搜索"
          class="search-btn"
          v-model="filterText"
        ></el-input>
        <el-tree
          :props="defaultProps"
          :load="loadNode"
          node-key="id"
          ref="tree"
          highlight-current
          lazy
          :expand-on-click-node="true"
          @node-click="handleNodeClick"
          class="organization-tree"
          icon-class="el-icon-arrow-right"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import systemNoticeInfoDialog from "@base/views/user/system_notice/infoDialog.vue";
import commMenuDialog from "@base/views/user/commMenu/index.vue";
import notifyMessageDialog from "@base/views/user/notify_message/dialog.vue";
import notifyMessageInfoDialog from "@base/views/user/notify_message/infoDialog";

import { getToken } from "@base/utils/auth";
import wfContentDialog from "@base/views/user/wf/wf_manage/wfContentDialog";
import corejsConfig from "@/corejsConfig";
import { mapGetters } from "vuex";

export default {
  name: "home",
  props: {
    wf_manage_url: String,
  },
  components: {
    systemNoticeInfoDialog,
    commMenuDialog,
    notifyMessageDialog,
    notifyMessageInfoDialog,
    wfContentDialog,
  },
  data() {
    return {
      defaultProps: {
        label: "label", //这里是树结构中需显示的数据（即接口返回的需展示在页面上的参数）
        children: [],
        isLeaf: "leaf",
      },
      filterText: null,
      showCompanyDialog: false,
      choose_company_info: "",

      showNoticeDialog: false,
      showGroupDialog: false,
      notifyTemplates: [],
      userInfo: {},
      companyInfo: {},
      systemNotices: [],
      showSystemNoticeInfoDialog: false,
      csnRow: null,
      headPhotoUrl: "",
      dialogVisible: true,
      unDoWfRows: [],
      wfOption: {},
      showWfDialog: false,
      wfContentOption: {},
      showWfContent: true,
      wfContent: null,
      wfDataId: "",
      showCommMenuDialog: false,
      commMenus: [],
      notifyMessages: [],
      notifyMessageInfoIndex: null,
      notifyMessageInfoId: null,
      unreadMessageNum: 0,
      activating: true,
      wfTimer: null,
      homeConfig: corejsConfig.homeConfig || {},
      menuModules: [],
      workbenchMenus: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
    ...mapGetters(["sidebarRouters"]),
  },
  activated() {
    this.activating = true;
    if (this.wfTimer) {
      this.timerExcFun(true);
    }
  },
  deactivated() {
    this.activating = false;
  },
  beforeDestroy() {
    this.clearTimer();
  },
  created() {
    this.getUserInfo();
    this.initSystemNotice();
    this.initCommMenu();
    this.initNotifyMessage();
    this.initWfParam();
    this.initWfTimer();
    this.initMenu();
    this.initWorkbenchMenu();
  },
  mounted() {
    // setTimeout(() => {
    //   debugger
    //   this.filterRoute();
    // }, 100);
  },
  methods: {
    handleNodeClick(data, node, v) {
      if (!data.hasChild) {
        this.choose_company_info = data;
        this.changeCompany();
      } else {
        this.choose_company_info = {};
      }
    },
    // 异步树叶子节点懒加载逻辑
    loadNode(node, resolve) {
      let companyCode =
        node && node.data && node.data.companyCode
          ? node.data.companyCode || ""
          : "";
      let url = !companyCode
        ? USER_PREFIX + "/user_company_info/getAllList"
        : USER_PREFIX + "/user_company_info/getChildren";

      this.$http({
        url: url,
        method: "post",
        data: {
          parentCompanyCode: companyCode,
        },
        success: (res) => {
          let datas = res.objx || [];
          let parentLabel = companyCode ? node.label : null;
          datas.forEach((item) => {
            item.leaf = !item.hasChild;
            let label = item.companyName;
            /*if(companyCode){
              label = label + '('+companyTypeMap[item.companyType]+')'
            }*/
            item.label = label;
            item.parentLabel = parentLabel;
          });

          if (node.level === 0) {
            if (datas.length > 0 && datas[0].hasChild) {
              this.$nextTick(() => {
                let nodedata = node.childNodes[0];
                nodedata.expanded = true;
                nodedata.loadData();
              });
            }
          }
          resolve(datas);
        },
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      let flag1 = data.label.indexOf(value) !== -1;
      let flag2 = data.parentLabel && data.parentLabel.indexOf(value) !== -1;
      return flag1 || flag2;
    },
    openCompanyDialog() {
      this.filterText = null;
      this.showCompanyDialog = true;
    },
    getWebPrefix(callback) {
      this.$http({
        url: USER_PREFIX + "/auth/getWebPrefix",
        method: `post`,
        data: {},
        isLoading: true,
        success: (res) => {
          let webPrefix = res.objx;
          callback && callback(webPrefix);
        },
      });
    },
    changeCompany() {
      let row = this.choose_company_info;
      let query = this.$route.query;
      let flag = query && query.flag === 1 ? 1 : null;
      this.showCompanyDialog = false;
      if (row && row.companyCode) {
        this.$baseLoading({ target: document.body, fullscreen: true });
        this.$http({
          url: USER_PREFIX + "/auth/switchCompany",
          method: "post",
          data: { stringOne: row.companyCode },
          isLoading: true,
          success: (res) => {
            this.getWebPrefix((prefix) => {
              let webPrefix = prefix ? "/" + prefix : window.MAIN_WEB_PREFIX;
              sessionStorage.removeItem("out-token");
              this.$store.dispatch("user/changeCompanyInfo", row);
              this.$store.dispatch("tagsView/delAllViews");
              window.location.href = webPrefix + "/index.html";
            });
          },
        });
      } else {
        if (flag === 1) {
          this.$router.push({
            path: "/",
          });
        }
      }
    },
    changeCompanyClose() {
      let query = this.$route.query;
      let flag = query && query.flag === 1 ? 1 : null;
      if (flag === 1) {
        this.$router.push({
          path: "/",
        });
      }
      this.showCompanyDialog = false;
    },
    initWorkbenchMenu() {
      this.$http({
        url: USER_PREFIX + "/workbench_menu/getAll",
        method: "post",
        data: {},
        success: (res) => {
          let workbenchMenus = res.objx || [];
          this.workbenchMenus = workbenchMenus;
        },
      });
    },
    jumpOutLink(route) {
      let path = route.url || route.path;
      if (route.type === 4 && path) {
        let params = this.getCustomReqUrlAndCleanUrl(path);
        let reqUrl = params.custom_req_url;
        if (reqUrl) {
          this.$http({
            url: reqUrl,
            method: `post`,
            data: { thirdUrl: params.newUrl },
            isLoading: true,
            success: (res) => {
              path = res.objx;
              window.open(path);
            },
          });
        } else {
          if (path.indexOf("token={token}") >= 0) {
            path = path.replace("token={token}", "token=" + getToken());
          }
          window.open(path);
        }
      }
    },
    flattenTree(data) {
      const result = [];

      // 使用深度优先遍历递归函数
      function dfs(node) {
        if (!node) return;

        // 将当前节点添加到结果数组（排除children属性）
        const { children, ...rest } = node;
        result.push(rest);

        // 递归处理子节点
        if (children && children.length > 0) {
          children.forEach((child) => dfs(child));
        }
      }

      // 处理输入数据（支持数组和单个对象）
      if (Array.isArray(data)) {
        data.forEach((item) => dfs(item));
      } else if (data) {
        dfs(data);
      }

      return result;
    },
    getRoute(row) {
      let menuCode = row.menuCode;
      let routes = this.flattenTree(this.$baseEventBus.menuModules);
      let route = routes.find((item) => item.menuCode === menuCode);
      return route;
    },
    openRoutePath(row) {
      let menuCode = row.menuCode;
      if (menuCode === "todo") {
        this.$message.error("功能正在完善，敬请期待。");
        return;
      }
      let routes = this.flattenTree(this.sidebarRouters);
      let route = routes.find((item) => item.menuCode === menuCode);
      if (!route) {
        this.$message.error("菜单没有访问权限");
        return;
      }
      this.rourteTo(route);
    },
    rourteTo(route) {
      let path = route.url || route.path;
      if (!path) {
        return;
      }
      this.showMenuModal = true;
      setTimeout(() => {
        this.showMenuModal = false;
      }, 200);
      try {
        if (route.linkType === 4) {
          this.jumpOutLink(route);
        } else if (route.linkType === 3) {
          this.$router.push({
            path: path,
            query: { url: route.outLink, route: route.route },
          });
        } else {
          this.$router.push(path);
        }
      } catch (e) {
        console.error(e);
      }
    },

    initMenu() {
      this.$baseEventBus.$on("reloadHomeMenu", (menuId) => {
        this.$forceUpdate();
      });
    },
    filterRoute() {
      let oldRoutes = JSON.parse(JSON.stringify(this.sidebarRouters));
      let nRoute1s = [];
      oldRoutes.forEach((route1, index1) => {
        let nRoute2s = [];
        if (!route1.hidden) {
          route1.children.forEach((route2, index2) => {
            let nRoute3s = [];
            if (!route2.hidden) {
              route2.children.forEach((route3, index3) => {
                if (!route3.hidden) {
                  nRoute3s.push(route3);
                }
              });
            }
            if (route2.type === 4 || route2.url || nRoute3s.length > 0) {
              route2.children = nRoute3s;
              nRoute2s.push(route2);
            }
          });
        }
        if (route1.type === 4 || route1.url || nRoute2s.length > 0) {
          route1.children = nRoute2s;
          nRoute1s.push(route1);
        }
      });

      this.menuModules = nRoute1s || [];
    },
    logout() {
      this.$store.dispatch("user/logout2").then((res) => {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      });
    },
    wfClose() {
      this.timerExcFun(true);
    },
    initWfTimer() {
      this.wfTimer = setInterval(() => {
        this.timerExcFun(false);
      }, 10000);
      this.timerExcFun(true);
    },
    timerExcFun(isLoading) {
      if (!this.activating) {
        return;
      }
      this.getWfInfoList(isLoading);
      this.getUnreadMessageNum(isLoading);
      this.$emit("timerHandle");
    },
    clearTimer() {
      clearInterval(this.wfTimer);
      this.wfTimer = null;
    },
    getUserInfo() {
      this.$http({
        url: USER_PREFIX + "/user/currentUser",
        method: "post",
        success: (res) => {
          let userInfo = res.objx;
          this.headPhotoUrl = userInfo.headPhotoUrl
            ? userInfo.headPhotoUrl
            : require("@/resources/images" + "/default-header.png");

          this.userInfo = userInfo;
        },
      });
      this.$http({
        url: USER_PREFIX + "/company_info/getCurrent",
        method: `post`,
        success: (res) => {
          this.companyInfo = res.objx || {};
        },
      });
    },
    initSystemNotice() {
      this.$http({
        url: USER_PREFIX + "/system_notice/listPage",
        data: { publish: true, searchCount: false },
        method: "post",
        success: (res) => {
          this.systemNotices =
            res.objx && res.objx.records ? res.objx.records : [];
        },
      });
    },
    openSystemNoticeDialog(row) {
      this.csnRow = row || null;
      this.showSystemNoticeInfoDialog = true;
    },
    initUnDoWfInfo() {
      this.$http({
        url: AGILEBPM_PREFIX + "/wf_manage/listPage",
        data: { type: 0, searchCount: false },
        method: "post",
        success: (res) => {
          this.unDoWfRows = res.objx.records || [];
        },
      });
    },
    initWfTableList() {
      let that = this;
      let paramColumns = this.wfParamDTOs.map((item) => {
        return {
          title: this.$t1(item.paramName),
          field: item.paramKey,
          width: 150,
        };
      });
      let statuses = {
        running: this.$t1("审核中"),
        back: this.$t1("已驳回"),
        end: this.$t1("已完成"),
      };
      let tableOption = {
        vue: this,
        tableRef: "table-wf",
        tableName: "home-table-wf",
        config: {
          height: "auto",
          scrollY: {
            enabled: false,
          },
        },
        columns: [
          { type: "checkbox", width: 48, resizable: false, fixed: "left" },
          {
            title: this.$t1("单据类型"),
            field: "objTypeName",
            width: 150,
            fixed: "left",
          },
          {
            title: this.$t1("流程主题"),
            field: "name",
            width: 150,
          },
          {
            title: this.$t1("启动人"),
            field: "starterName",
            width: 150,
          },
          {
            title: this.$t1("当前任务"),
            field: "taskName",
            width: 150,
          },
          {
            title: this.$t1("当前任务用户"),
            field: "candidateNames",
            width: 150,
          },
          {
            title: this.$t1("启动时间"),
            field: "createDate",
            width: 150,
          },
          ...paramColumns,
          {
            width: 47,
            fixed: "right",
            title: "",
            sortable: false,
            slots: {
              default: ({ row }) => {
                return [
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openWfDialog(row);
                    }}
                  >
                    <el-tooltip
                      enterable={false}
                      effect="dark"
                      content={this.$t1("查看")}
                      placement="top"
                      popper-class="tooltip-skin"
                    >
                      <i class="el-icon-view" />
                    </el-tooltip>
                  </a>,
                ];
              },
            },
          },
        ],
      };
      this.$vxeTableUtil.initVxeTable(tableOption).then((opts) => {
        this.wfOption = opts;
      });
    },
    openWfDialog(row) {
      this.wfContentOption = {
        objId: row.objId,
        url: row.url,
        objTypeCode: row.objTypeCode,
      };
      this.showWfDialog = true;
    },
    commMenuCallBack(datas) {
      this.commMenus = datas || [];
    },
    initCommMenu() {
      this.$http({
        url: USER_PREFIX + "/comm_menu/currentList",
        data: { longOne: 0 },
        method: "POST",
      }).then((resultMsg) => {
        this.commMenus = resultMsg.objx || [];
      });
    },
    initNotifyMessage() {
      return;
      this.$http({
        url: USER_PREFIX + "/notify_message/listPage",
        data: { searchCount: false },
        method: "post",
        success: (res) => {
          this.notifyMessages =
            res.objx && res.objx.records ? res.objx.records : [];
        },
      });
    },
    openNotifyMessageDialog(row) {
      if (row.jumpContent) {
        this.$refs.notifyMessageDialog.open(row, () => {
          row.readed = 1;
        });
      }
    },
    openMoreNotifyMessage(notifyType) {
      let data = { notifyType: notifyType || "" };
      let view = {
        name: "notify_message:list",
        query: data,
      };
      this.$store.dispatch("tagsView/delCachedView", view).then(() => {
        this.$router.replace(view);
      });

      if (notifyType) {
        this.showGroupDialog = false;
      }
    },
    checkNotifyMessage(row, index) {
      this.showNoticeDialog = true;
      this.notifyMessageInfoIndex = index;
      this.notifyMessageInfoId = row.id;
    },
    notifyMessageReadHanlde() {
      this.notifyMessages[this.notifyMessageInfoIndex].readed = 1;
    },
    openNotifyTemplateGroupDialog() {
      this.$http({
        url: USER_PREFIX + `/notify_template/listPage`,
        method: `post`,
        data: { searchCount: false },
        isLoading: true,
        // loadingTarget: document.body,
        success: (res) => {
          this.notifyTemplates =
            res.objx && res.objx.records ? res.objx.records : [];
          this.showGroupDialog = true;
        },
      });
    },
    rourteTo(route) {
      if (route.type === 4) {
        this.jumpOutLink(route);
      } else if (route.type === 3) {
        let menuCode = route.menuCode;
        let path = "/user/outLink/index/" + menuCode;
        this.$router.push({ path: path, query: { url: route.url } });
      } else {
        let path = this.getPath(route);
        if (!path) return;
        this.$router.push(path);
      }
    },
    getPath(route3) {
      let item = null;
      let path = null;
      if (route3.type === 0) {
        //普通菜单
        if (route3.url) {
          path = route3.route || route3.url;
          let str = "/report/vform/render/";
          if (path.indexOf(str) === 0) {
          } else {
            let pIndex = path.indexOf("?");
            if (pIndex > 0) {
              path = path.substring(0, pIndex);
            }
          }
        }
      } else if (route3.type === 5) {
        //动态表单
        let url = route3.route || route3.url;
        path = url;
      }
      if (path && path.startsWith("@")) {
        path = null;
      }
      return path;
    },
    jumpOutLink(route) {
      let path = route.url;
      if (route.type === 4 && path) {
        if (path.indexOf("token={token}") >= 0) {
          path = path.replace("token={token}", "token=" + getToken());
        }
        window.open(path);
      }
    },
    initWfParam() {
      return this.$http({
        url: USER_PREFIX + "/wf_param/list",
        method: `post`,
        data: {},
        isLoading: true,
        // loadingTarget: document.body,
        modalStrictly: true,
        success: (res) => {
          this.wfParamDTOs = res.objx || [];
          // this.initWfTableList();
        },
      });
    },
    getWfInfoList(isLoading) {
      if (!this.activating) {
        return;
      }
      this.$http({
        url: USER_PREFIX + "/wf_info/listPage",
        data: { type: 0, size: 20, searchCount: false },
        method: "post",
        isLoading: isLoading,
        modal: isLoading || false,
        // loadingTarget: document.body,
        success: (res) => {
          this.unDoWfRows =
            res.objx && res.objx.records ? res.objx.records : [];
        },
        failMsg: false,
        errorMsg: false,
        fail: (res, response) => {
          if (response && response.status === 200) {
            this.$errorMsg(res);
          }
        },
      });
    },
    getUnreadMessageNum(isLoading) {
      if (!this.activating) {
        return;
      }
      return this.$http({
        url: USER_PREFIX + "/notify_message/countMessage",
        method: `post`,
        data: {},
        isLoading: isLoading,
        modal: isLoading || false,
        // loadingTarget: document.body,
        success: (res) => {
          this.unreadMessageNum = res.objx || 0;
        },
        failMsg: false,
        errorMsg: false,
        fail: (res, response) => {
          if (response && response.status === 200) {
            this.$errorMsg(res);
          }
        },
      });
    },
    wfhandleCallback(flag) {
      if ([1, 2, 3].includes(flag)) {
        this.showWfDialog = false;
        this.wfClose();
      }
    },
    toWfManageList() {
      let url = this.wf_manage_url || "/basic/wf/wf_manage/list";
      this.$router.push(url);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
::v-deep .el-link {
  color: rgba(0, 0, 0, 0.65);
  .iconfont {
    margin-right: 4px;
    font-size: 14px;
  }
  &:hover {
    color: $baseColor;
  }
}
.workbenches {
  padding: 18px 24px 0px;
}
.workbenches-head {
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 16px;
  line-height: 1;
  font-size: 14px;
  .icon-haier {
    color: $baseColor;
    font-size: 24px;
    margin-right: 16px;
  }
  .logo {
    height: 30px;
    vertical-align: middle;
  }
  > span {
    margin-right: 16px;
    &.f-blue {
      font-size: 16px;
      vertical-align: middle;
      line-height: 1;
      display: inline-block;
    }
  }
}
.workbenches-box {
  height: calc(100vh - 94px); /**margin-bottom: 16px;*/
  > .el-row {
    height: 100%;
    > .el-col {
      height: 100%;
    }
  }
  .w-box {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    height: 100%;
    .w-b-head {
      overflow: hidden;
      margin: 16px 24px;
      .tit {
        b {
          font-size: 16px;
          font-weight: 600;
          vertical-align: middle;
        }
        .nums {
          margin-left: 8px;
          border-radius: 4px;
          width: 20px;
          height: 20px;
          display: inline-block;
          background-color: #ff4d4f;
          color: #fff;
          text-align: center;
          line-height: 20px;
          font-style: inherit;
          font-size: 12px;
          vertical-align: middle;
        }
      }
      .el-link {
        margin-left: 24px;
      }
    }
  }
  .wnotice-box {
    padding: 0 24px 4px;
    overflow: auto;
    height: calc(100% - 52px);
    .item {
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 12px;
      display: flex;
      margin-bottom: 12px;
      line-height: 18px;
      cursor: pointer;
      font-size: 14px;
      .no-read {
        background-color: #faad14;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        font-style: inherit;
        line-height: 18px;
        padding: 0 4px;
        margin-right: 8px;
      }
      .name {
        flex: 1;
      }
      .date {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
      }
      &:hover {
        border-color: $baseColor;
        .name {
          color: $baseColor;
        }
      }
    }
  }
  .agenda-box {
    padding: 0 24px 4px;
    overflow: auto;
    height: calc(100% - 52px);
    .item {
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 12px;
      cursor: pointer;
      p {
        margin: 0;
      }
      .name {
        margin-bottom: 8px;
        font-size: 14px;
      }
      .info {
        font-size: 12px;
        > span {
          margin-right: 32px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      &:hover {
        border-color: $baseColor;
        .name {
          color: $baseColor;
        }
      }
    }
  }
  .use-cases {
    overflow: auto;
    padding: 0 24px 4px;
    height: calc(100% - 52px);
    .item {
      margin-bottom: 32px;
      .t {
        &:before {
          content: "";
          width: 4px;
          height: 15px;
          border-radius: 4px;
          background: $baseColor;
          margin-right: 8px;
          vertical-align: middle;
          display: inline-block;
        }
        span {
          vertical-align: middle;
          font-size: 14px;
        }
      }
      .c {
        padding: 2px 12px;
        .i-block {
          display: inline-block;
          width: 84px;
          margin-right: 52px;
          text-align: center;
          font-size: 12px;
          margin-top: 18px;
          cursor: pointer;
          vertical-align: top;
          .icon {
            width: 44px;
            height: 44px;
            border-radius: 8px;
            color: #fff;
            display: block;
            margin: 0 auto 8px;
            font-size: 20px;
            font-style: inherit;
            line-height: 44px;
          }
          &:hover {
            color: $baseColor;
          }
          .tips {
            zoom: 0.8;
            display: inline-block;
            line-height: 1.2;
            margin: 0 -42px 8px;
          }
        }
      }
    }
  }
}
.workbenches-info {
  padding: 0 24px;
  margin: 0 -24px;
  background: #fff;
  height: 50px;
  display: flex;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  .w-left {
    padding: 10px 0;
    height: 100%;
    text-align: right;
    vertical-align: middle;
    flex: 1;
    zoom: 0.9;
    span {
      margin: 3px 0px;
      display: block;
    }
  }
  .w-right {
    line-height: 74px;
  }
}
</style>
